AoPS.Utils.initKeyChain(AoPS, "Ebooks", "Url");

AoPS.Ebooks.Url = (function (EbkUrl) {
	// Dependencies
	var UrlTable = AoPS.UrlTable;

	var main = new UrlTable.Table({
		data: {
			// code: Backbone Router URL pattern
			index: "",
			book_notrail: ":booksku",
			book: ":booksku/*bookurl",
			book_preview: ":booksku/preview",
			edge: "edge/:booksku/:sectioncode",
			error: "error",
		},
		// Root URL to Ebooks, which all href's have prepended.
		root_url: "/ebooks/",
		// URL to Ebooks images
		image_path: "/ebooks/images/",
	});

	function createBookTable(options) {
		options = options || {};
		return new UrlTable.Table({
			data: {
				index: "",
				last: "last",
				section: ":sectioncode",
				section_label: ":sectioncode/label/:labelid",
				section_paragraph: ":sectioncode/par/:paragraphid",
				section_problem: ":sectioncode/prob/:problemid",
				label: "label/:labelid",
				paragraph: "par/:parid",
				problem: "prob/:probid",
			},
			root_url: options.root_url || "/ebooks/" + options.book_code + "/",
			image_path: "/ebooks/images/",
		});
	}

	return {
		main: main,
		createBookTable: createBookTable,
	};
})();
